export const OSS_URL = 'https://lifecircle-mina-pay-project.oss-cn-hangzhou.aliyuncs.com/xcxPay/'
// export const MOCK_URL = 'http://127.0.0.1:4523/mock/1080865/' // mock地址

// 开放平台配置
const CURRENT_MAIN = 'fShows'
const OPEN_PLATFORM_CONFIG_INFO = {
  fShows: {
    appid: '202204265635014',
    vendor_sn: '', // 动态在缓存中获取
    salt: '', // 动态在缓存中获取
    versions: '1.0.0'
  }
}
export const CURRENT_MAIN_INFO = OPEN_PLATFORM_CONFIG_INFO[CURRENT_MAIN]

// 环境变量配置
export default function getEnv () {
  // 环境变量类型,值为：test、beta、prod
  const ENVIRONMENT_TYPE = 'prod'
  const VERSION = '1.0.1' // 组件版本号
  const APP_ID = `fs-wx-payment-component-${ENVIRONMENT_TYPE}`
  const environmentObj = {
    test: {
      LOG_PROJECT_NAME: 'fshows-ecs-pro',
      LOG_SEEDS_STORE: 'web-digital-business-log',
      REQUEST_URL: 'https://shq-api-test.51fubei.com/gateway/mina',
      BACK_REQUEST_URL: 'https://fubeiminagw-test.51youdian.com/gateway/mina'
    },
    beta: {
      VERSION,
      LOG_PROJECT_NAME: 'fshows-ecs-pro',
      LOG_SEEDS_STORE: 'web-digital-business-log',
      REQUEST_URL: 'https://shq-api-beta.51fubei.com/gateway/mina',
      BACK_REQUEST_URL: 'https://fubeiminagw-beta.51youdian.com/gateway/mina'
    },
    prod: {
      LOG_PROJECT_NAME: 'fshows-ecs-pro',
      LOG_SEEDS_STORE: 'web-digital-business-log',
      REQUEST_URL: 'https://shq-api.51fubei.com/gateway/mina',
      BACK_REQUEST_URL: 'https://fubeiminagw.51youdian.com/gateway/mina'
    }
  }

  return {
    ...environmentObj[ENVIRONMENT_TYPE],
    VERSION,
    APP_ID,
    ENVIRONMENT_TYPE // 正式站
  }
}
